
//NUEVO que te lleva al top
// document.addEventListener('DOMContentLoaded', function () {
//     const scrollButton = document.querySelector('.fixed-home');
//     const targetSection = document.getElementById('multicollection');
    
//     // Mostrar/ocultar botón basado en scroll
//     function onScroll() {
//         const triggerOffset = targetSection.offsetTop;
//         const scrollY = window.scrollY;

//         if (scrollY > triggerOffset) {
//             scrollButton.style.display = 'flex';
//         } else {
//             scrollButton.style.display = 'none';
//         }
//     }

//     // Escuchar evento de scroll
//     window.addEventListener('scroll', onScroll);

//     // Acción al hacer clic en el botón
//     scrollButton.addEventListener('click', (e) => {
//         e.preventDefault(); // Evita el comportamiento predeterminado
//         window.scrollTo({ top: 0, behavior: 'smooth' }); // Desplazamiento suave al inicio
//     });

//     // Inicialización: asegura que el botón esté oculto al cargar la página
//     scrollButton.style.display = 'none';
// });


// //debuggeado
// document.addEventListener('DOMContentLoaded', function () {
//     const buttons = [
//         { selector: '.fixed-pdp', target: null }, // Botón para ir al inicio
//         { selector: '.fixed-home', target: '#multicolumn' } // Botón para ir a una sección específica
//     ];
//     const targetSection = document.getElementById('prop-value');

//     if (!targetSection) {
//         console.error("Error: No se encontró la sección objetivo con ID 'prop-value'");
//         return;
//     }

//     // Mostrar/ocultar botones basado en scroll
//     function onScroll() {
//         const triggerOffset = targetSection.offsetTop;
//         const scrollY = window.scrollY;

//         buttons.forEach(buttonConfig => {
//             const button = document.querySelector(buttonConfig.selector);
//             if (button) {
//                 if (scrollY > triggerOffset) {
//                     button.style.display = 'flex';
//                 } else {
//                     button.style.display = 'none';
//                 }
//             } 
//             // else {
//             //     console.warn(`Advertencia: No se encontró el botón con selector '${buttonConfig.selector}'`);
//             // }
//         });
//     }

//     // Acción al hacer clic en los botones
//     function onButtonClick(event, target) {
//         event.preventDefault();
//         if (target) {
//             const targetElement = document.querySelector(target);
//             if (targetElement) {
//                 targetElement.scrollIntoView({ behavior: 'smooth' });
//             } else {
//                 console.error(`Error: No se encontró el destino con selector '${target}'`);
//             }
//         } else {
//             window.scrollTo({ top: 0, behavior: 'smooth' });
//         }
//     }

//     // Inicialización de botones
//     buttons.forEach(buttonConfig => {
//         const button = document.querySelector(buttonConfig.selector);
//         if (button) {
//             button.style.display = 'none'; // Ocultar botones al inicio
//             button.addEventListener('click', (e) => onButtonClick(e, buttonConfig.target));
//         } 
//         // else {
//         //     console.warn(`Advertencia: No se encontró el botón con selector '${buttonConfig.selector}'`);
//         // }
//     });

//     // Escuchar evento de scroll
//     window.addEventListener('scroll', onScroll);
// });

  

//oculta en footer

document.addEventListener('DOMContentLoaded', function () {
    const buttons = [
        { selector: '.fixed-pdp', target: null }, // Botón para ir al inicio
        { selector: '.fixed-home', target: '#multicolumn' } // Botón para ir a una sección específica
    ];
    const targetSection = document.getElementById('prop-value');
    const footer = document.getElementById('footer'); // Cambia esto por el selector real del footer

    if (!targetSection || !footer) {
        console.error("Error: Sección objetivo o footer no encontrados");
        return;
    }

    // Mostrar/ocultar botones basado en scroll
    function onScroll() {
        const triggerOffset = targetSection.offsetTop;
        const scrollY = window.scrollY;
        const footerRect = footer.getBoundingClientRect();

        buttons.forEach(buttonConfig => {
            const button = document.querySelector(buttonConfig.selector);
            if (button) {
                if (scrollY > triggerOffset && footerRect.top > window.innerHeight) {
                    button.style.display = 'flex'; // Mostrar si el footer no está visible
                } else {
                    button.style.display = 'none'; // Ocultar si el footer está visible o si no se ha alcanzado el offset
                }
            }
        });
    }

    // Acción al hacer clic en los botones
    function onButtonClick(event, target) {
        event.preventDefault();
        if (target) {
            const targetElement = document.querySelector(target);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            } else {
                console.error(`Error: No se encontró el destino con selector '${target}'`);
            }
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    // Inicialización de botones
    buttons.forEach(buttonConfig => {
        const button = document.querySelector(buttonConfig.selector);
        if (button) {
            button.style.display = 'none'; // Ocultar botones al inicio
            button.addEventListener('click', (e) => onButtonClick(e, buttonConfig.target));
        }
    });

    // Escuchar evento de scroll
    window.addEventListener('scroll', onScroll);
});
